import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.module.scss';
import App from './App';
import User from './store/user-store';

const userStore = new User();

export const Context = createContext(userStore);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value = {userStore}>
        <App />
    </Context.Provider>
);

